import { makeStyles } from '@material-ui/core/styles';

const exceptionStyles = makeStyles(theme => ({
  root: {
    textAlign: 'center',
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
  },
}));

export default exceptionStyles;
